import React from "react";
import { Link } from "react-router-dom";

/**
 * Global error boundary. Prevents the entire app from rendering blank when a
 * single component throws (e.g., API timeout, malformed data, runtime bug).
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[Secret Angels] Render error:", error, info?.componentStack);
  }
  reset = () => {
    this.setState({ error: null });
    if (window.location.pathname !== "/") window.location.href = "/";
    else window.location.reload();
  };
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center px-6 bg-[#FAF9F6]">
          <div className="max-w-md text-center">
            <div className="text-xs tracking-[0.3em] uppercase text-[#6B6A63]">Algo salió mal</div>
            <h1 className="font-serif text-4xl mt-2 text-[#1A2118]">Ups, ocurrió un error</h1>
            <p className="text-sm text-[#6B6A63] mt-3">
              Hemos registrado el problema. Vuelve al inicio y vuelve a intentarlo.
            </p>
            <button onClick={this.reset} className="btn-primary mt-6">
              Volver al inicio
            </button>
            <div className="mt-3 text-xs">
              <Link to="/" className="text-[#364531] underline">Ir a la página principal</Link>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
